module.exports = __webpack_public_path__ + "img/porto-1.edb673d0.png";